export enum UpsertTypes {
	create = 'Create',
	edit = 'Edit',
	copy = 'Copy',
	delete = 'Delete',
}
